import React from "react";
import ShopFloorImg from "../assets/images/new-dashboards/shop.png";
import DataIcon from "../assets/icons/data.png";
import ClockIcon from "../assets/icons/clock.png";
import ConsumptionIcon from "../assets/icons/consumption.png";
import { ContactForm } from "../components/ContactForm";

export function LucidShopFloor() {
  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <section className="newModuleHeader">
        <div className="newBackground"></div>
        <h3 className="mainSubhead white">Alpaca Shop Floor</h3>
        <p className="body-text white">
          Easily manage your shop production with this simple to use app.
        </p>
        <img
          src={ShopFloorImg}
          alt="Alpaca Shop Floor Dashboard"
          className="module-img"
        />
      </section>

      <section className="module-info">
        <div>
          <p className="body-text left">
            As the name of the module implies, Alpaca ShopFloor allows for
            <strong>
              {" "}
              data and information to flow from the “shop floor” or area of
              activity.
            </strong>{" "}
            With customized user interfaces that operate on web-based devices,
            the operator can input data in real-time, receive instructions, and
            updates.
            <br />
            <br />
            This process eliminates notes taken on paper that at a later date
            are entered in the business system, which cause delays, errors, and
            additional costs.
          </p>
        </div>

        <div>
          <div className="container-img-text">
            <img src={DataIcon} alt="Data Collection Icon" />
            <div>
              <h3 className="smallSubhead">Data Collection</h3>
              <p className="small-text">
                Paperless data gathering directly from the shop floor on your
                preferred web-based device.
              </p>
            </div>
          </div>

          <div className="container-img-text">
            <img src={ClockIcon} alt="Real-Time Info Icon" />
            <div>
              <h3 className="smallSubhead">Real Time Info</h3>
              <p className="small-text">
                By having the data collection point at the point of activity,
                real-time data is available.
              </p>
            </div>
          </div>

          <div className="container-img-text">
            <img src={ConsumptionIcon} alt="Consumption Tracking Icon" />
            <div>
              <h3 className="smallSubhead">Consumption Tracking</h3>
              <p className="small-text">
                Tracking material consumption is a breeze with Alpaca ShopFloor.
                The app connects directly to your work centers and tracks what
                material is being used and where.
              </p>
            </div>
          </div>
        </div>
      </section>
      <ContactForm />
    </>
  );
}
